import React, { FunctionComponent, MouseEventHandler } from 'react';
import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Dialog,
} from '@material-ui/core';
import styled from 'styled-components';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';

const StyledDialog = styled(Dialog)`
  .MuiDialogContent-root {
    background-color: #f7f7f7;
    padding: 20px;
    min-width: 316px;
  }
  #primary-button-style,
  #secondary-button-style {
    height: 36px;
    padding: 5px;
  }
`;

export interface SahamDialogProps {
  open: boolean;
  handleClose: MouseEventHandler;
  handleValidate: MouseEventHandler;
  title: string;
  cancelTitle: string;
  confirmTitle: string;
  className?: string;
  validateButtonDisabled?: boolean;
}

const SahamDialog: FunctionComponent<SahamDialogProps> = (
  props,
): JSX.Element => {
  return (
    <StyledDialog open={props.open} onClose={props.handleClose}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent className={props.className}>
        {props.children}
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          title={props.cancelTitle}
          onClick={props.handleClose}
        />
        <PrimaryButton
          title={props.confirmTitle}
          onClick={props.handleValidate}
          disabled={props.validateButtonDisabled}
        />
      </DialogActions>
    </StyledDialog>
  );
};

SahamDialog.defaultProps = {
  validateButtonDisabled: false,
};

export default SahamDialog;
